import React, { useMemo } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const scores = [6, 5, 5, 5, 3, 4, 6, 4, 5];
const labels = [
  "Introducción a la Innovación",
  "Negocios",
  "Marketing y Turismo",
  "Derecho",
  "Programación Junior",
  "Programación Intermedia y Avanzada",
  "Electrónica/Automatización/Robótica",
  "Introducción al Desarrollo de Páginas Web",
  "Producción Industrial",
];

const options = {
  fill: true,
  animations: false,
  scales: {
    y: {
      min: 0,
    },
  },
  responsive: true,
  plugins: {
    legend: {
      display: true,
    },
  },
};

export default function BarChart({ totalCo, totalEx, exProjects, coProjects }) {
  var r = [];

  for (let i = 0; i < coProjects.length; i++) {
    r[i] = coProjects[i] - exProjects[i];
  }

  var t = totalCo - totalEx;

  const data = useMemo(function () {
    return {
      datasets: [
        {
          label: "Competencia (" + t + ")",
          tension: 0.3,
          data: r,
          borderColor: "rgb(75, 192, 192)",
          backgroundColor: "rgba(75, 192, 192, 0.6)",
        },
        {
          label: "Exhibición (" + totalEx + ")",
          tension: 0.3,
          data: exProjects,
          borderColor: "rgb(0, 192, 192)",
          backgroundColor: "rgba(0, 255, 0, 0.6)",
        },
      ],
      labels,
    };
  }, []);

  return (
    <div className="App">
      <Bar data={data} options={options} />
    </div>
  );
}
